import type { ThemeKey } from "@/lib/theme-review";

/** Public reader pages for the four fixed editorial themes. URLs are new (no prior page existed). */
export const THEME_PAGES: { key: ThemeKey; slug: string; title: string; question: string }[] = [
  { key: "planet", slug: "insan-ve-gezegen", title: "İnsan ve Gezegen", question: "Dünyayı değiştirmeye çalışırken, onunla birlikte yaşamayı unuttuk mu?" },
  { key: "tech", slug: "teknoloji-ve-guc", title: "Teknoloji ve Güç", question: "Yapabildiklerimiz arttıkça, neyi yapmamamız gerektiğine nasıl karar vereceğiz?" },
  { key: "economy", slug: "ekonomi-ve-toplum", title: "Ekonomi ve Toplum", question: "Ekonomiyi şekillendirirken, ekonomi bizi nasıl şekillendiriyor?" },
  { key: "meaning", slug: "insan-ve-anlam", title: "İnsan ve Anlam", question: "Nasıl yaşadığımızı belirleyen sistemlerin içinde, nasıl yaşamak istediğimize kim karar veriyor?" },
];

export const themeBySlug = (slug: string) => THEME_PAGES.find((t) => t.slug === slug);
export const themeByKey = (key: string | null | undefined) => THEME_PAGES.find((t) => t.key === key);

export type ApprovedTheme = { slug: string; primary: ThemeKey; secondary: ThemeKey | null };
